module.exports = __webpack_public_path__ + "img/star-1.749a106d.png";